import { applicationBorrowerApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const BORROWER_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/borrower`,
  {
    DELETE_BORROWER: 'DELETE_BORROWER',
    BULK_UPDATE: 'BULK_UPDATE',
  },
);

export const deleteApplicationBorrowerAction = catchAsyncActionError(
  ({ applicationId, borrowerId, tabId, withLoanOptionId }) =>
    async dispatch => {
      const { data } = await applicationBorrowerApi.deleteBorrower({
        applicationId,
        borrowerId,
        tabId,
        withLoanOptionId,
      });

      return dispatch({
        type: BORROWER_ACTION_TYPE.DELETE_BORROWER,
        payload: data,
        meta: { borrowerId },
      });
    },
);

export const bulkUpdateBorrowersAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationBorrowerApi.bulkUpdateBorrowers(params);

  return dispatch({
    type: BORROWER_ACTION_TYPE.BULK_UPDATE,
    payload: data,
  });
});

export const refreshBorrowerCreditEventsAction = catchAsyncActionError(params => async () => {
  const { data } = await applicationBorrowerApi.refreshBorrowerCreditEvents(params);

  return data;
});
